import Vue from "vue";
import Router from "vue-router";
import defaultPages from "./modules/default";
import loggedPages from "./modules/logged";
import shared from "./modules/shared";
import store from "@/state/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [...defaultPages, ...loggedPages, ...shared]
});
router.beforeEach((to, from, next) => {
  // window.scrollTo(0, 0);
  // eslint-disable-next-line no-console
  ("beforeeach");
  if (!to.meta.middleware) {
    return next();
  } else {
    const middleware = to.meta.middleware;
    const context = {
      to,
      from,
      next,
      store
    };
    return middleware[0]({
      ...context
    });
  }
});

export default router;
